import {
  useEffect,
  useState,
  useCallback
} from "react";

import {
  useParams,
  useNavigate
} from "react-router-dom";

import Swal from "sweetalert2";


import Navbar from "../components/Navbar";
import { useAuth } from "../context/AuthContext";
import api, { API_URL } from "../services/api";

function EditAd() {

  const { id } = useParams();

  const navigate = useNavigate();

  const { token } = useAuth();

  const [imageFile, setImageFile] =
    useState(null);

  const [updating, setUpdating] =
    useState(false);

  const [formData, setFormData] =
    useState({

      title: "",
      image_url: "",
      redirect_url: "",
      position: "",
      is_active: true

    });

  const loadAd = useCallback(async () => {

    try {

      const response =
        await api.get(`/ads/${id}`);

      const ad =
        response.data;

      setFormData({

        title:
          ad.title || "",

        image_url:
          ad.image_url || "",

        redirect_url:
          ad.redirect_url || "",

        position:
          ad.position || "",

        is_active:
          ad.is_active ?? true

      });

    } catch (error) {

      console.error(error);

      Swal.fire({

        icon: "error",

        title: "Error",

        text:
          "Failed to load advertisement."

      });

    }

  }, [id]);

  useEffect(() => {

    loadAd();

  }, [loadAd]);

  const handleChange = (e) => {

    const {

      name,
      value,
      checked,
      type

    } = e.target;

    setFormData({

      ...formData,

      [name]:
        type === "checkbox"
          ? checked
          : value

    });

  };

  const uploadImage =
    async () => {

      if (!imageFile) {

        return formData.image_url;

      }

      const uploadData =
        new FormData();

      uploadData.append(
        "file",
        imageFile
      );

      uploadData.append(
        "folder",
        "ads"
      );

      const response =
        await api.post(

          "/upload/image",

          uploadData,

          {

            headers: {

              Authorization:
                `Bearer ${token}`,

              "Content-Type":
                "multipart/form-data"

            }

          }

        );

      return response.data.image_url;

    };

  const handleSubmit =
    async (e) => {

      e.preventDefault();

      try {

        setUpdating(true);

        Swal.fire({

          title:
            "Updating Advertisement...",

          allowOutsideClick:
            false,

          didOpen: () => {

            Swal.showLoading();

          }

        });

        const image_url =
          await uploadImage();

        await api.patch(

          `/ads/${id}`,

          {

            ...formData,

            image_url

          },

          {

            headers: {

              Authorization:
                `Bearer ${token}`

            }

          }

        );

        Swal.fire({

          icon: "success",

          title: "Success",

          text:
            "Advertisement updated successfully.",

          timer: 2000,

          showConfirmButton:
            false

        });

        navigate("/ads/manage");

      } catch (error) {

        console.error(error);

        Swal.fire({

          icon: "error",

          title:
            "Update Failed",

          text:
            error.response?.data?.message ||
            "Unable to update advertisement."

        });

      } finally {

        setUpdating(false);

      }

    };

  return (

    <div>

      <Navbar />

      <div className="form-container">

        <h1>Edit Advertisement</h1>

        <form
          onSubmit={handleSubmit}
        >

          <input
            type="text"
            name="title"
            placeholder="Title"
            value={formData.title}
            onChange={handleChange}
            required
          />

          {formData.image_url && (

            <div
              style={{
                marginBottom: "20px"
              }}
            >

              <label>

                <strong>
                  Current Image
                </strong>

              </label>

              <br />

              <img
                src={`${API_URL}${formData.image_url}`}
                alt={formData.title}
                style={{
                  width: "250px",
                  marginTop: "10px",
                  borderRadius: "8px"
                }}
              />

            </div>

          )}

          <div
            style={{
              marginBottom: "20px"
            }}
          >

            <label>

              <strong>
                Upload New Image
              </strong>

            </label>

            <input
              type="file"
              accept="image/*"
              onChange={(e) =>
                setImageFile(
                  e.target.files[0]
                )
              }
            />

          </div>

          <input
            type="text"
            name="redirect_url"
            placeholder="Redirect URL"
            value={formData.redirect_url}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="position"
            placeholder="Position"
            value={formData.position}
            onChange={handleChange}
            required
          />

          <label>

            Active Advertisement{" "}

            <input
              type="checkbox"
              name="is_active"
              checked={
                formData.is_active
              }
              onChange={
                handleChange
              }
            />

          </label>

          <button
            type="submit"
            disabled={updating}
          >

            {updating
              ? "Updating..."
              : "Update Advertisement"}

          </button>

        </form>

      </div>

    </div>

  );

}

export default EditAd;